import {
  ChakraBox,
  ChakraFlex,
  EquipUIFireflyV2Theme,
  getGroupClassIconElement,
  GroupClassIllustrations,
  InputGroupV2,
} from '@equip.health/ui';
import {
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
  GroupClassBaseFieldProps,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupIcons = ({
  value: iconName,
  onChange,
  isNew = false,
}: GroupClassBaseFieldProps<string> & { isNew?: boolean }) => {
  const { primary, mono } = EquipUIFireflyV2Theme.colors;

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__icon`}
      isRequired
      label="Icon"
      shouldShowAsteriskWhenRequired
    >
      <ChakraFlex flexWrap="wrap" gap={isNew ? '12px' : '8px'}>
        {Object.keys(GroupClassIllustrations).map(
          (key: GroupClassIllustrations) => {
            return (
              <ChakraBox
                background={iconName === key ? primary[10] : ''}
                border={`2px solid ${key === iconName ? primary[50] : mono[5]}`}
                borderRadius="12px"
                cursor="pointer"
                key={key}
                marginBottom={isNew ? undefined : '12px'}
                marginRight={isNew ? undefined : '12px'}
                onClick={() => onChange(key)}
                padding={isNew ? '11px' : '8px'}
              >
                {getGroupClassIconElement(key)}
              </ChakraBox>
            );
          },
        )}
      </ChakraFlex>
    </InputGroupV2>
  );
};
